import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Button, Divider } from 'antd';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import HeaderBack from '../../../components/mobile/HeaderBack';
import BoxUserCallMethod from '../../../components/mobile/user-account/BoxUserCallMethod';
import { putPatienAPICall } from '../../../api/patient';
import AuthService from '../../../services/AuthService'

const auth = new AuthService()
const styles = {
  divider: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
}

function MobileContactPreferenceScreen() {
  const { t } = useTranslation(['user-account', 'common']);
  const history = useHistory();
  const profile = auth.getUserProfile()

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        preferred_comm_platform: Yup.string().required(t('common:form.error.required'))
      }),
    [t]
  );

  const onBack = () => {
    history.push('/user-account')
  }

  const initialValues = {
    preferred_comm_platform: profile.preferred_comm_platform ?? 'direct',
  };

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('user-account:contactPreference.previousPage')}
        title={t('user-account:contactPreference.title')}
        subtitle={t('user-account:contactPreference.subtitle')}
      />
      <Box marginBottom={20}>
        <Divider plain><p style={styles.divider}>{t('user-account:contactPreference.talkMeOn')}</p></Divider>
      </Box>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values) => {
          const dataForm = { ...values };
          const { responseOk, responseJSON } = await putPatienAPICall(dataForm);
          if (responseOk) {
            auth.updateUserAppMetadataInLocalStorage(responseJSON)
            history.push('/user-account');
          }
        }}
      >
        {({ isSubmitting, isValid, values }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <BoxUserCallMethod fieldName="preferred_comm_platform" selectedMethod={values.preferred_comm_platform} />
                <Box marginTop={30} paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    <p style={styles.rowButton}>
                      {
                        isSubmitting
                        ? <LoadingSpinner position="full" transparent={false} />
                        : (
                            <>
                              {t('common:button.confirmSaveChange')}
                            </>
                          )
                      }
                    </p>
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default MobileContactPreferenceScreen;
